// BETA-ONLY: Remove this feature when beta ends

export interface QuestionOption {
  value: string;
  label: string;
}

// Q1: Monthly admin time
export const MONTHLY_ADMIN_TIME_OPTIONS: QuestionOption[] = [
  { value: 'under_2_hours', label: 'Less than 2 hours' },
  { value: '2_to_6_hours', label: '2-6 hours' },
  { value: '7_to_15_hours', label: '7-15 hours' },
  { value: '16_to_30_hours', label: '16-30 hours' },
  { value: '31_plus_hours', label: '31+ hours' },
];

// Q2: Pain points (multi-select)
export const PAIN_POINT_OPTIONS: QuestionOption[] = [
  { value: 'missed_deadline', label: 'Missed a deadline' },
  { value: 'coverage_denial_appeal', label: 'Coverage denial or appeal' },
  { value: 'delayed_care_paperwork', label: 'Delayed care due to paperwork' },
  { value: 'billing_issue', label: 'Billing issue' },
  { value: 'lost_disorganized_documents', label: 'Lost or disorganized documents' },
  { value: 'coordination_difficulties', label: 'Coordination difficulties' },
  { value: 'none', label: 'None of these' },
];

// Q3: Current tools (multi-select)
export const CURRENT_TOOL_OPTIONS: QuestionOption[] = [
  { value: 'paper', label: 'Paper files' },
  { value: 'computer_folders', label: 'Computer folders' },
  { value: 'cloud_storage', label: 'Cloud storage (Google Drive, Dropbox, etc.)' },
  { value: 'spreadsheets', label: 'Spreadsheets' },
  { value: 'calendar', label: 'Calendar app' },
  { value: 'other_app', label: 'Another app' },
  { value: 'my_memory', label: 'My memory' },
];

// Q4: Top outcome
export const TOP_OUTCOME_OPTIONS: QuestionOption[] = [
  { value: 'never_miss_deadlines', label: 'Never miss a deadline' },
  { value: 'find_documents_fast', label: 'Find any document in seconds' },
  { value: 'less_stress_mental_load', label: 'Less stress and mental load' },
  { value: 'better_letters_appeals', label: 'Better advocacy letters and appeals' },
  { value: 'coordinate_care_team', label: 'Easier coordination with care team' },
];

// Q5: Referral source
export const REFERRAL_SOURCE_OPTIONS: QuestionOption[] = [
  { value: 'friend_family', label: 'Friend or family member' },
  { value: 'social_media', label: 'Social media' },
  { value: 'caregiver_community', label: 'Caregiver community or support group' },
  { value: 'healthcare_provider', label: 'Healthcare provider' },
  { value: 'search', label: 'Web search' },
  { value: 'other', label: 'Other' },
];

// Q6: Feedback comfort
export const FEEDBACK_COMFORT_OPTIONS: QuestionOption[] = [
  { value: 'happy_calls_surveys', label: 'Yes \u2014 happy to do calls and surveys' },
  { value: 'occasionally', label: 'Occasionally' },
  { value: 'quick_feedback_only', label: 'Prefer quick feedback only' },
];

export interface BetaProfileFormData {
  monthlyAdminTime: string;
  painPoints: string[];
  currentTools: string[];
  topOutcome: string;
  referralSource: string;
  feedbackComfort: string;
}

export interface SubmitBetaProfileResponse {
  success: boolean;
  message?: string;
  error?: string;
}
